import Vue from "vue";
import Router from "vue-router";
import paths from "./paths";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  routes: paths,
});

// router gards
router.beforeEach((to, from, next) => {
  //console.log(to.name);
  if(
    to.name === 'Home' || 
    to.name === 'Blog' || 
    to.name === 'Articulo' || 
    to.name === 'ArticuloPanel' || 
    to.name === 'FooterPanel' || 
    to.name === 'PoliticasPanel' || 
    to.name === 'CategoriasPanel' || 
    to.name === 'PlanesPanel' || 
    to.name === 'About' || 
    to.name === 'Aviso' ||  
    to.name === 'Login' || 
    to.name === 'NotFound' ||
    to.name === 'Presentacion'
    ){
    if(to.name === 'ArticuloPanel' || to.name === 'FooterPanel' || to.name === 'PoliticasPanel' || to.name === 'CategoriasPanel' || to.name === 'PlanesPanel'){
      if(localStorage.getItem("logged")){
        next();
      }else{
        next('/admin/login');
      }
    }else{
      next();
    }
  }else{
    if(to.path === '/'){
      next('/home');
    }else{
      next('/404');
    }
  }
});

router.afterEach((to, from) => {
  
});

export default router;
